// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__gktH6","main":"Layout_main__evUHx","footer":"Layout_footer__bkcZ6","version":"Layout_version__8uzu5"};